/**
 * Screenshot.ts
 *
 * A module for screenshot. It uses the html2canvas package.
 */

import * as html2canvas from "feedback-html2canvas/src";

/**
 * Get screenshot
 * @param domElement document element or document body 
 * @param options background color
 */
export function createScreenshot(domElement?: object, options?: any): Promise<HTMLCanvasElement> {
	return html2canvas(domElement || document.body, { background: "#ffffff", ...options });
}
